import { ReportCriteriaConst } from "../../report-form/report-criteria-form/report-criteria-constants";
import { ReportParametersBuilder } from "../../report-form/report-criteria-form/set-metadata-defaulet-values";
import { ReportManagerConstant } from "../shared/report-manager.constant";
export class ReportMngCriteriaInit extends ReportParametersBuilder {
    ucFirst;
    datePipe;
    reportMetadata;
    myForm;
    application;
    jobID;
    constructor(ucFirst, datePipe, reportMetadata, myForm, application, jobID) {
        super(ucFirst, datePipe, reportMetadata, myForm);
        this.ucFirst = ucFirst;
        this.datePipe = datePipe;
        this.reportMetadata = reportMetadata;
        this.myForm = myForm;
        this.application = application;
        this.jobID = jobID;
    }
    setReportCriteria(reportCriteriaRow) {
        let formGroup;
        if (reportCriteriaRow.CriteriaFieldLabel) {
            reportCriteriaRow.CriteriaFieldLabel = this.ucFirst.transform(reportCriteriaRow.CriteriaFieldLabel.toLowerCase());
        }
        if (this.checkIfRowIsApplicationID(reportCriteriaRow)) {
            reportCriteriaRow.IsApplicationId = true;
        }
        if (this.checkIfRowIsJobID(reportCriteriaRow)) {
            reportCriteriaRow.IsJobId = true;
        }
        this.reportCriteriaRow = reportCriteriaRow;
        formGroup = this.reportCriteriaFrm();
        this.reportCriteria.push(formGroup);
    }
    checkIfRowIsApplicationID(reportCriteriaRow) {
        if (!reportCriteriaRow || !reportCriteriaRow.CriteriaName) {
            return false;
        }
        const value = ReportManagerConstant.DefaultApplicationIdFields.findIndex((f) => f === reportCriteriaRow.CriteriaName.toLowerCase().replace(" ", ""));
        return value > -1;
    }
    checkIfRowIsJobID(reportCriteriaRow) {
        if (!reportCriteriaRow || !reportCriteriaRow.CriteriaName) {
            return false;
        }
        const value = ReportManagerConstant.DefaultJobdFields.findIndex((f) => f === reportCriteriaRow.CriteriaName.toLowerCase().replace(" ", ""));
        return value > -1;
    }
    reportCriteriaFrm() {
        const form = this.formSetup();
        let control;
        control = this.preparValidation();
        form.addControl(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL, control);
        if (this.reportCriteriaRow.IsApplicationId) {
            form
                .get(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL)
                .setValue(this.application.appId.toString());
        }
        if (this.reportCriteriaRow.IsJobId) {
            form
                .get(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL)
                .setValue(this.jobID.toString());
        }
        return form;
    }
}
